<template>
  <el-dialog
    :title="$t('Product.Type')"
    :visible.sync="dialogVisible"
    v-model="dialogVisible"
    :close-on-click-modal="false"
    custom-class="minheight"
    @close="closeDialog"
    append-to-body
  >
    <!--工具条-->
    <toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
      :selectBut="false"
    ></toolbar>
    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
    >
      <el-table-column prop="Id" label="Id" width="60"></el-table-column>
      <el-table-column :label="$t('Sort')" prop="Sort"></el-table-column>
      <el-table-column :label="$t('Name')">
        <template slot-scope="scope">{{ field(scope.row.Name) }}</template>
      </el-table-column>
      <el-table-column prop="Created" :label="$t('Created')" width="140">
        <template slot-scope="scope">{{
          formatDate(scope.row.Created)
        }}</template>
      </el-table-column>
      <el-table-column prop="Enabled" :label="$t('Enabled')" width="90">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Enabled ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.Enabled ? $t("enabled") : $t("disable") }}</el-tag
          >
        </template>
      </el-table-column>
    </el-table>

    <!--新增-->
    <el-dialog
      :title="$t('add')"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form :model="addForm" label-width="150px" ref="addForm" size="small">
        <LangTabs>
          <template v-slot:main="slot">
            <el-form-item
              :label="$t('Name')"
              :prop="'Name.' + slot.langkey"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Name'),
              }"
            >
              <el-input v-model="addForm.Name[slot.langkey]"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Sort')"
              prop="Sort"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Sort'),
              }"
            >
              <el-input
                type="number"
                v-model.number="addForm.Sort"
                style="width: 200px"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('Enabled')">
              <el-switch v-model="addForm.Enabled"></el-switch>
            </el-form-item>
          </template>
          <template v-slot:other="slot">
            <el-form-item :label="$t('Name')">
              <el-input v-model="addForm.Name[slot.item.key]"></el-input>
            </el-form-item>
          </template>
        </LangTabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>

    <!--修改-->
    <el-dialog
      :title="$t('edit')"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
        :model="editForm"
        label-width="150px"
        ref="editForm"
        size="small"
      >
        <LangTabs>
          <template v-slot:main="slot">
            <el-form-item
              :label="$t('Name')"
              :prop="'Name.' + slot.langkey"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Name'),
              }"
            >
              <el-input v-model="editForm.Name[slot.langkey]"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Sort')"
              prop="Sort"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Sort'),
              }"
            >
              <el-input
                type="number"
                v-model.number="editForm.Sort"
                style="width: 200px"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('Enabled')">
              <el-switch v-model="editForm.Enabled"></el-switch>
            </el-form-item>
          </template>
          <template v-slot:other="slot">
            <el-form-item :label="$t('Name')">
              <el-input v-model="editForm.Name[slot.item.key]"></el-input>
            </el-form-item>
          </template>
        </LangTabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>
    <div slot="footer" class="dialog-footer"></div>
  </el-dialog>
</template>

<script>
import util from "util/date";
import {
  base,
  getProductTypeListPage,
  removeProductType,
  editProductType,
  addProductType,
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";
export default {
  data() {
    return {
      shopId: 0,
      baseCoverUrl: base + "/FileUpload/FlatImg/a0/",
      buttonList: [],
      list: [],
      listLoading: false,
      currentRow: null,
      dialogVisible: false,
      //新增界面数据
      addFormVisible: false,
      addLoading: false,
      addForm: { Name: {} },
      //修改界面数据
      editFormVisible: false,
      editLoading: false,
      editForm: {},
    };
  },
  inject: ["getProductBasis"],
  methods: {
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy/MM/dd hh:mm");
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.Func].apply(this, item);
    },
    closeDialog() {
      this.getProductBasis();
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        Sort: 0,
        Name: {},
        Shop_Id: this.shopId,
        Enabled: true,
      };
    },
    //新增活动
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.addLoading = true;
              let para = Object.assign({}, this.addForm);
              addProductType(para).then((res) => {
                this.addLoading = false;
                if (util.isEmt.format(res)) {
                  return;
                }
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    //显示编辑活动界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, this.clone(row));
    },
    //编辑活动
    editSubmit: function () {
      let _this = this;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.editLoading = true;
              let para = Object.assign({}, this.editForm);
              editProductType(para).then((res) => {
                this.editLoading = false;
                if (util.isEmt.format(res)) {
                  return;
                }
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.$refs.listTable.setCurrentRow();
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      this.$confirm(this.$t("deletePrompt"), this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeProductType(para).then((res) => {
            this.listLoading = false;
            if (util.isEmt.format(res)) {
              return;
            }
            if (res.data.success) {
              this.$message({
                message: this.$t("deleteSuccess"),
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getList();
          });
        })
        .catch(() => {});
    },
    //获取列表
    getList() {
      let _this = this;
      let para = { shopId: this.shopId };
      this.listLoading = true;
      getProductTypeListPage(para).then((res) => {
        this.list = res.data.response;
        this.listLoading = false;
      });
    },
    loadData(sid) {
      this.shopId = sid;
      this.getList();
      this.dialogVisible = true;
      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      this.buttonList = getButtonList("/Shop/ProductType", routers);
    },
  },
};
</script>
